// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-collapsible-row-collapsed {
    width: '1px';
    min-width: '1px';
    background-color: var(--color-grey000);
    padding: 0;
}

.table-collapsible-row-expanded {
    padding: 0;
    margin: 0;
    width: 100%;
    background-color: var(--color-mapDarkBackround);
}

.table-collapsible-row-expanded td {
    vertical-align: top;
}

.table-collapsible-row-collapsed:hover {
    background-color: var(--color-grey300);
}

/* alarm column styles */
.table-collapsible-row-collapsed td:last-child {
    text-align: right;
    padding-right: 1px;
    width: 1px;
}

/* Checkbox column styles */
.table-collapsible-row-collapsed td:nth-last-child(2) {
    text-align: right;
}

/* These are just placeholders and can be adjusted as per your design needs. */
.red {
    background-color: red;
}

.yellow {
    background-color: yellow;
}

.none {
    background-color: transparent;
    /* Or any other default color you wish. */
}

.table-collapsible-row-action-bar {
    display: flex;
    justify-content: center;
    /* This aligns the icons to the right */
    position: relative;
    z-index: 2;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 5px;
    padding: 10px;
    -webkit-backdrop-filter: blur(1px);
            backdrop-filter: blur(1px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    max-width: 400px;
    max-height: 300px;
    margin: 10px;
}

.table-collapsible-row-action-bar>* {
    position: relative;
    margin-left: 30px;
    font-size: 20px;
    color: var(--color-grey900);
    transition: color 0.3s ease;
    z-index: 1;
    /* This ensures the icon stays above the pseudo-element */
}

.table-collapsible-row-action-bar>*::before {
    content: "";
    /* Necessary for the pseudo-element to appear */
    position: absolute;
    /* This positions the circle relative to the icon */
    top: 50%;
    left: 50%;
    width: 24px;
    /* Width of the circle; adjust as needed */
    height: 24px;
    /* Height of the circle; adjust as needed */
    transform: translate(-50%, -50%) scale(0);
    /* Centers the circle behind the icon and starts it at 0 size */
    border-radius: 50%;
    /* Makes it circular */
    z-index: -1;
    /* Places the circle behind the icon */
    transition: transform 0.3s ease;
    /* Animation for smooth scaling */
}

.table-collapsible-row-action-bar>*:hover {
    color: var(--color-grey000);
}

.table-collapsible-row-action-bar>*:hover::before {
    transform: translate(-50%, -50%) scale(1);
    /* Scale to its original size on hover */
}

.table-collapsible-row-action-bar> :last-child {
    margin-right: 30px;
}`, "",{"version":3,"sources":["webpack://./src/components/TableCollapsibleRow.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,gBAAgB;IAChB,sCAAsC;IACtC,UAAU;AACd;;AAEA;IACI,UAAU;IACV,SAAS;IACT,WAAW;IACX,+CAA+C;AACnD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA,wBAAwB;AACxB;IACI,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;AACd;;AAEA,2BAA2B;AAC3B;IACI,iBAAiB;AACrB;;AAEA,8EAA8E;AAC9E;IACI,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,6BAA6B;IAC7B,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,uCAAuC;IACvC,kBAAkB;IAClB,UAAU;IACV,0CAA0C;IAC1C,kBAAkB;IAClB,aAAa;IACb,kCAA0B;YAA1B,0BAA0B;IAC1B,wCAAwC;IACxC,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,2BAA2B;IAC3B,2BAA2B;IAC3B,UAAU;IACV,yDAAyD;AAC7D;;AAEA;IACI,WAAW;IACX,+CAA+C;IAC/C,kBAAkB;IAClB,mDAAmD;IACnD,QAAQ;IACR,SAAS;IACT,WAAW;IACX,0CAA0C;IAC1C,YAAY;IACZ,2CAA2C;IAC3C,yCAAyC;IACzC,+DAA+D;IAC/D,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,sCAAsC;IACtC,+BAA+B;IAC/B,iCAAiC;AACrC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yCAAyC;IACzC,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".table-collapsible-row-collapsed {\n    width: '1px';\n    min-width: '1px';\n    background-color: var(--color-grey000);\n    padding: 0;\n}\n\n.table-collapsible-row-expanded {\n    padding: 0;\n    margin: 0;\n    width: 100%;\n    background-color: var(--color-mapDarkBackround);\n}\n\n.table-collapsible-row-expanded td {\n    vertical-align: top;\n}\n\n.table-collapsible-row-collapsed:hover {\n    background-color: var(--color-grey300);\n}\n\n/* alarm column styles */\n.table-collapsible-row-collapsed td:last-child {\n    text-align: right;\n    padding-right: 1px;\n    width: 1px;\n}\n\n/* Checkbox column styles */\n.table-collapsible-row-collapsed td:nth-last-child(2) {\n    text-align: right;\n}\n\n/* These are just placeholders and can be adjusted as per your design needs. */\n.red {\n    background-color: red;\n}\n\n.yellow {\n    background-color: yellow;\n}\n\n.none {\n    background-color: transparent;\n    /* Or any other default color you wish. */\n}\n\n.table-collapsible-row-action-bar {\n    display: flex;\n    justify-content: center;\n    /* This aligns the icons to the right */\n    position: relative;\n    z-index: 2;\n    background-color: rgba(255, 255, 255, 0.8);\n    border-radius: 5px;\n    padding: 10px;\n    backdrop-filter: blur(1px);\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    max-width: 400px;\n    max-height: 300px;\n    margin: 10px;\n}\n\n.table-collapsible-row-action-bar>* {\n    position: relative;\n    margin-left: 30px;\n    font-size: 20px;\n    color: var(--color-grey900);\n    transition: color 0.3s ease;\n    z-index: 1;\n    /* This ensures the icon stays above the pseudo-element */\n}\n\n.table-collapsible-row-action-bar>*::before {\n    content: \"\";\n    /* Necessary for the pseudo-element to appear */\n    position: absolute;\n    /* This positions the circle relative to the icon */\n    top: 50%;\n    left: 50%;\n    width: 24px;\n    /* Width of the circle; adjust as needed */\n    height: 24px;\n    /* Height of the circle; adjust as needed */\n    transform: translate(-50%, -50%) scale(0);\n    /* Centers the circle behind the icon and starts it at 0 size */\n    border-radius: 50%;\n    /* Makes it circular */\n    z-index: -1;\n    /* Places the circle behind the icon */\n    transition: transform 0.3s ease;\n    /* Animation for smooth scaling */\n}\n\n.table-collapsible-row-action-bar>*:hover {\n    color: var(--color-grey000);\n}\n\n.table-collapsible-row-action-bar>*:hover::before {\n    transform: translate(-50%, -50%) scale(1);\n    /* Scale to its original size on hover */\n}\n\n.table-collapsible-row-action-bar> :last-child {\n    margin-right: 30px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
